import CTA from '../../cta/cta.constants';
import MY_LIST_ICONS from './myListCallToAction.constants';
import { SELECTED_SIGNAL } from '../signals';
import { CallToAction as CallToActionPrimary } from '../callToAction/primary/callToAction.component';
import { CallToAction as CallToActionSecondary } from '../callToAction/secondary/callToAction.component';
import { makeBookmarkAction } from './myListCallToAction.utils';

export const WithBookmarkToggle = base =>
  class BookmarkToggle extends base {
    set isBookmarked(value) {
      this._isBookmarked = value;
      this.picto = value ? MY_LIST_ICONS.MY_LIST_ICON_BOOKED : MY_LIST_ICONS.MY_LIST_ICON_UNBOOKED;
      if (this._item) {
        this._item.state = this._isBookmarked;
        this._item.action = makeBookmarkAction(this._item.id, this._isBookmarked ? CTA.UNBOOKMARK : CTA.BOOKMARK);
      }
    }

    set item(value) {
      if (!value) {
        return;
      }

      this._item = { ...value };
      this.isBookmarked = this._item.state;
    }

    set blockIndex(value) {
      this._blockIndex = value;
    }

    set itemIndex(value) {
      this._itemIndex = value;
    }

    _handleEnter() {
      if (!this._item) {
        return;
      }
      this.signal(SELECTED_SIGNAL, {
        ...this._item,
        blockIndex: this._blockIndex,
        itemIndex: this._itemIndex,
      });
    }
  };

export const MyListButtonPrimary = WithBookmarkToggle(CallToActionPrimary);

export const MyListButtonSecondary = WithBookmarkToggle(CallToActionSecondary);
